/* eslint-disable import/prefer-default-export */
import irelandApi from '../irelandApi';

const POR_DEALS_URL = '/api/por_deals';

export const getPorDeals = (brandId = '', isProduct = '', outlet, sort) => (dispatch) => {
  dispatch({ type: 'GET_POR_DEALS_PENDING', payload: [] });
  return irelandApi
    .get(`${POR_DEALS_URL}?outlet=${outlet}&sort=${sort}&brand_id=${brandId}&is_product=${isProduct}`)
    .then((response) => {
      const payload = response.data ? response.data : { data: false };
      dispatch({ type: 'GET_POR_DEALS_FULFILLED', payLoad: payload });
    })
    .catch((error) => {
      dispatch({ type: 'GET_POR_DEALS_REJECTED', payLoad: error });
    });
};

export const getInactivePorDeals = () => (dispatch) => {
  dispatch({ type: 'GET_INACTIVE_POR_DEALS_PENDING', payload: [] });
  const url = `${POR_DEALS_URL}/inactive`;
  return irelandApi
    .get(url)
    .then((response) => {
      const payload = response.data ? response.data : { data: false };
      dispatch({ type: 'GET_INACTIVE_POR_DEALS_FULFILLED', payLoad: payload });
    })
    .catch((error) => {
      dispatch({ type: 'GET_INACTIVE_POR_DEALS_REJECTED', payLoad: error });
    });
};



// WEBPACK FOOTER //
// ./src/actions/por-deals.js